import SegmentRule from "../services/model/SegmentRule";
import { VALUE_LESS_OPERATORS } from "../constants/segmentConstants";

/**
 * Checks if a single rule is valid (has field, operator, and value when required).
 */
export const isValidRule = (rule: SegmentRule): boolean =>
  Boolean(rule.field) &&
  Boolean(rule.operator) &&
  (VALUE_LESS_OPERATORS.includes(
    rule.operator as (typeof VALUE_LESS_OPERATORS)[number]
  ) ||
    rule.value !== "");

/**
 * Checks if an array of rules are all valid.
 */
export const areRulesValid = (rules: SegmentRule[]): boolean => {
  if (!rules || rules.length === 0) return false;
  return rules.every(isValidRule);
};
